module.exports = __webpack_public_path__ + "static/media/hospitals.1be83eba.png";